export interface ICustomerVerificationFormNames {
    'purchasedOn[day]'?: string,
    'purchasedOn[month]'?: string,
    'purchasedOn[year]'?: null,
    'reviewToken': string,
    'customerNumber': string,
    'firstName': string,
    'lastName': string,
    'email': string,
}

export interface ICustomerVerificationParam {
    rtoken: string,
    pdate: string,
    cno: string,
    fname: string,
    lname: string,
    email: string,
}

export interface ICustomerVerificationService {
    isValid(): boolean;
    getMappedParamsToFormNames(): object;
}

class CustomerVerificationService implements ICustomerVerificationService {
    private urlParams: URLSearchParams;

    constructor() {
        const queryString = window.location.search;
        this.urlParams =  new URLSearchParams(queryString);
    }

    public isValid(): boolean {
        return this.getRToken().length === 32;
    }

    public getMappedParamsToFormNames(): object {
        const params = this.getParams();
        const purchasedDate = params.pdate?.match(/^(?<year>\d{4})-(?<month>\d{2})-(?<date>\d{2})$/);

        let formNames: ICustomerVerificationFormNames = {
            'purchasedOn[day]': null,
            'purchasedOn[month]': null,
            'purchasedOn[year]': null,
            'reviewToken': params.rtoken,
            'customerNumber': params.cno,
            'firstName': params.fname,
            'lastName': params.lname,
            'email': params.email,
        };

        if (purchasedDate) {
            formNames = {
                ...formNames,
                'purchasedOn[day]': purchasedDate.groups.date,
                'purchasedOn[month]': purchasedDate.groups.month,
                'purchasedOn[year]': purchasedDate.groups.year,
            }
        }

        return formNames;
    }

    private getRToken(): string {
        return this.urlParams.get('rtoken') ?? '';
    }

    private getParams(): ICustomerVerificationParam {
        return {
            rtoken: this.getRToken(),
            pdate: this.urlParams.get('pdate'),
            cno: this.urlParams.get('cno'),
            fname: this.urlParams.get('fname'),
            lname: this.urlParams.get('lname'),
            email: this.urlParams.get('email'),
        };
    }
}

export const customerVerificationService = new CustomerVerificationService();
